import { render, staticRenderFns } from "./lazyselects.vue?vue&type=template&id=3c807b87"
import script from "./lazyselects.vue?vue&type=script&lang=js"
export * from "./lazyselects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports